<template>
  <div id="product-capacity">
    <div class="open-platform-header-text">
      <h1>{{ lanInfo.title[3] }}</h1>
    </div>
    <div class="content-width">
      <div class="product-block" v-for="(item, index) of lanInfo.productContent" v-bind:key="index">
        <span></span>
        <div class="product-block-item">
          <h5>{{ item.name }}</h5>
          <p :title="item.text" v-html="item.text"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "openPlatformDetailProduct",
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
}
</script>

<style scoped lang="scss">
.content-width {
  width: 1200px;
  margin: 0 auto;
}

.open-platform-header-text {
  text-align: center;
  padding: 40px 0;

  h1 {
    color: #000000;
    font-size: 26px;
  }
}

#product-capacity {
  background: #fafafa;
  padding-bottom: 40px;

  .content-width {
    display: flex;
    flex-wrap: wrap;
  }

  .product-block {
    background: #fff;
    display: flex;
    height: 140px;
    margin-right: 20px;
    margin-bottom: 20px;
    flex-direction: row;
    padding-right: 20px;
    align-items: center;
    padding-left: 32px;

    span {
      width: 64px;
      height: 64px;
      margin-right: 24px;
      flex-shrink: 0;
    }

    .product-block-item {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h5 {
        color: #000000;
        line-height: 28px;
        font-size: 20px;
      }

      p {
        color: #787878;
        line-height: 22px;
        font-size: 14px;
        margin-top: 8px;
      }
    }

    &:nth-child(1) {
      width: 350px;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-1.png");
        background-size: cover;
      }
    }

    &:nth-child(2) {
      width: 460px;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-2.png");
        background-size: cover;
      }
    }

    &:nth-child(3) {
      width: 350px;
      margin-right: 0;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-3.png");
        background-size: cover;
      }
    }

    &:nth-child(4) {
      width: 830px;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-4.png");
        background-size: cover;
      }
    }

    &:nth-child(5) {
      width: 350px;
      margin-right: 0;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-5.png");
        background-size: cover;
      }
    }

    &:nth-child(6) {
      width: 580px;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-6.png");
        background-size: cover;
      }
    }

    &:nth-child(7) {
      width: 460px;

      span {
        background: url("../../assets/images/openPlatform/detail-product-n-7.png");
        background-size: cover;
      }
    }

    &:nth-child(8) {
      width: 120px;
      margin-right: 0;
      padding: 0;

      span {
        display: none;
      }

      h5 {
        font-size: 14px;
        text-align: center;
        width: 57px;
        margin-left: 32px;
        color: #0A57C9;
      }
    }

    &:hover {
      color: #fff;
      background: #0A57C9;

      h5,
      p {
        color: #fff;
      }

      &:nth-child(1) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-1.png");
          background-size: cover;
        }
      }

      &:nth-child(2) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-2.png");
          background-size: cover;
        }
      }

      &:nth-child(3) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-3.png");
          background-size: cover;
        }
      }

      &:nth-child(4) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-4.png");
          background-size: cover;
        }
      }

      &:nth-child(5) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-5.png");
          background-size: cover;
        }
      }

      &:nth-child(6) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-6.png");
          background-size: cover;
        }
      }

      &:nth-child(7) {
        span {
          background: url("../../assets/images/openPlatform/detail-product-h-7.png");
          background-size: cover;
        }
      }
    }
  }
}

</style>